// Import local images
import backgroundGlass from "@common/assets/images/background-glass.png";
import aiWandBadge from "@common/assets/images/ai-wand-badge.png";
import googleLogo from "@common/assets/images/google-logo.png";

export const images = {
  // Local images - 1:1 with images folder.
  "background-glass": backgroundGlass,
  "ai-wand-badge": aiWandBadge,
  "google-logo": googleLogo,
};
export type ImageName = keyof typeof images;
